import { useCallback, useState } from 'react';

export const useFeatureFlagUserStoreExpansion = () => {
  const [expandedUserIds, setExpandedUserIds] = useState<Set<string>>(() => new Set());

  const toggleUserStores = useCallback((userId: string) => {
    setExpandedUserIds((currentUserIds) => {
      const nextUserIds = new Set(currentUserIds);

      if (nextUserIds.has(userId)) {
        nextUserIds.delete(userId);
      } else {
        nextUserIds.add(userId);
      }

      return nextUserIds;
    });
  }, []);

  return {
    expandedUserIds,
    toggleUserStores,
  };
};
